import { render, staticRenderFns } from "./EduDetails.vue?vue&type=template&id=69c69116&scoped=true"
import script from "./EduDetails.vue?vue&type=script&lang=js"
export * from "./EduDetails.vue?vue&type=script&lang=js"
import style0 from "./EduDetails.vue?vue&type=style&index=0&id=69c69116&prod&scoped=true&lang=css"
import style1 from "./EduDetails.vue?vue&type=style&index=1&id=69c69116&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c69116",
  null
  
)

export default component.exports